import { render, staticRenderFns } from "./NotesModal.vue?vue&type=template&id=46b803d8&scoped=true"
import script from "./NotesModal.vue?vue&type=script&lang=js"
export * from "./NotesModal.vue?vue&type=script&lang=js"
import style0 from "./NotesModal.vue?vue&type=style&index=0&id=46b803d8&prod&module=true&scoped=true&lang=css"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "46b803d8",
  null
  
)

export default component.exports